import React  from 'react';
import {NavLink} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useForm } from '../../hooks/useForm';
import { startLogin } from '../../store/auth-actions';
//import Swal from 'sweetalert2';

//import PropTypes from 'prop-types';
import '../../assets/scss/style.scss';
//import Aux from "../_Aux";
// import Breadcrumb from "../../../App/layout/AdminLayout/Breadcrumb";
//import '../../../../node_modules/font-awesome/scss/font-awesome.scss';

export default function SignIn1 () {

    const dispatch = useDispatch();
    
    

    const [ formLoginValues, handleLoginInputChange ] = useForm({
        lEmail: 'test@metricas.net',
        lPassword: 'test123'
    });

    

    const { lEmail, lPassword } = formLoginValues;
    const handleLogin = ( e ) => {
        e.preventDefault();
        dispatch( startLogin( lEmail, lPassword ) );
    }




    return(    
        <div className="auth-wrapper">
                    <div className="auth-content">
                        <div className="auth-bg">
                            <span className="r"/>
                            <span className="r s"/>
                            <span className="r s"/>
                            <span className="r"/>
                        </div>
                        <div className="card">
                            <div className="card-body text-center">
                                <div className="mb-4">
                                    <i className="feather icon-unlock auth-icon"/>
                                </div>
                                <h3 className="mb-4">Login</h3>
                                
                                <p className="mb-3">* For demo site use the pre-filled credentials and click Login</p>


                                <form onSubmit={ handleLogin }>
                                    <div className="form-group">
                                        <div className="input-group mb-3">
                                            <input 
                                                type="email" 
                                                className="form-control" 
                                                placeholder="Email"
                                                name="lEmail"
                                                value={ lEmail }
                                                onChange={ handleLoginInputChange }
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-group mb-4">
                                            <input 
                                                type="password" 
                                                className="form-control" 
                                                placeholder="Password"
                                                name="lPassword"
                                                value={ lPassword }
                                                onChange={ handleLoginInputChange }
                                            />
                                        </div>
                                    </div>    
                                    <div className="form-group text-left">
                                        <div className="checkbox checkbox-fill d-inline">
                                            <input 
                                                type="checkbox" 
                                                name="checkbox-fill-1" 
                                                id="checkbox-fill-a1" 
                                            />
                                            <label htmlFor="checkbox-fill-a1" className="cr"> Guardar credenciales</label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <button className="btn btn-primary shadow-2 mb-4">Login</button>
                                        <p className="mb-2 text-muted">Olvidó su password? <NavLink to="/reset-password-1">Reset</NavLink></p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
        </div>
    );
    
}

